module.exports = __webpack_public_path__ + "img/delete.e7cf1342.svg";